/* TGGCore: Opens the Tidio chat widget from any [data-tgg-chat] control.
   Used by the contact page's "Live chat" method and by the delivery
   directory's no-match card. Tidio loads async and its API appears late,
   so we poll briefly on click rather than binding to an API that may not
   exist yet. If chat never becomes available the control falls back to
   email, so the visitor is never left with a dead control. */
(function () {
  'use strict';

  function openChat() {
    var api = window.tidioChatApi;
    if (api && typeof api.open === 'function') {
      api.open();
      return true;
    }
    return false;
  }

  function fallback(btn) {
    // On the delivery card the visitor already has a Contact us button
    // beside this link, so a silent hide beats hijacking them into a mail
    // client. On the contact page the email method is the intended
    // fallback, since chat and email sit there as equal choices.
    var email = btn.closest('.sup-empty__chat')
      ? null
      : document.querySelector('.cthm-m__in[href^="mailto:"]');
    if (email) {
      window.location.href = email.getAttribute('href');
      return;
    }
    hide(btn);
  }

  // The contact page wraps the trigger in a card; elsewhere the trigger
  // stands on its own, so hide whichever is the visible unit.
  function hide(btn) {
    var unit = btn.closest('.cthm-m') || btn.closest('.sup-empty__chat') || btn;
    unit.hidden = true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tgg-chat]');
    if (!btn) return;
    e.preventDefault();

    if (openChat()) return;

    // Tidio may still be booting: retry for ~3s before giving up.
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (openChat() || tries > 30) {
        clearInterval(timer);
        if (tries > 30) fallback(btn);
      }
    }, 100);
  });

  // Hide the chat method entirely if the Tidio script was never loaded
  // (blocked, or the app is uninstalled), so we do not advertise a channel
  // that cannot open.
  document.addEventListener('DOMContentLoaded', function () {
    var hasTidio = !!document.querySelector('script[src*="tidio"]');
    if (hasTidio) return;
    document.querySelectorAll('[data-tgg-chat]').forEach(hide);
  });
})();
